<template>
  <GcBaseLayout
    :title="screenConfig.title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageRefreshKey"
    :backButtonEnable="backButtonEnable"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="tabsAccessControl"
    :selectedIndex="screenConfig.selectedIndex"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        :title="screenConfig.title"
        :screenName="getScreenName"
      />
    </template>

    <div class="css-v2 transaction-list">
      <GcDataGrid
        :grouping="true"
        :export="true"
        :summary="true"
        :dataSourceConfig="screenConfig.gridData.gridOptions.dataSource"
        :columns="screenConfig.gridData.columns"
        :id="'transaction-list-grid'"
        ref="transactionListGrid"
        :isLocalDataSource="
          !!screenConfig.gridData.gridOptions.dataSource.localDataList
        "
        :isEditableGrid="false"
        :showFooter="false"
        :gridOptions="screenConfig.gridData.gridOptions"
        :rowClick="rowClickCallBack"
        :gridToolbar="screenConfig.gridData.toolbar"
        :exportFileName="screenConfig.exportFileName"
        v-if="loaded && loadDataGrid"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :defaultUserSettings="defaultUserSettings"
      />
    </div>

    <gc-popup
      :popup-visible="gcPopupVisible"
      :popup-title="gcPopupConfig.title"
      :back-button-function="popUpBackButtonClick"
      :popupHeight="'auto'"
      v-if="gcPopupConfig && gcPopupVisible"
      :saveValidation="gcPopUpSaveOption"
      :saveButtonConfig="gcPopupConfig.save"
      :backButtonConfig="gcPopupConfig.back"
      :data-model="gcPopupConfig.dataModel"
      :ref="'transaction-list-grid-form-popup'"
      :id="'transaction-list-grid-form-popup'"
      :popupWidth="
        gcPopupConfig.popupWidth ? gcPopupConfig.popupWidth : undefined
      "
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="gcPopupConfig.formOptions"
          :formItems="gcPopupConfig.items"
          :formHeight="gcPopupConfig.height ? gcPopupConfig.height : 'auto'"
          :isNormal="true"
          :data-model="gcPopupConfig.dataModel ? gcPopupConfig.dataModel : {}"
          :formMode="baseView.mode"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          v-if="gcPopupConfig.items"
          :valueChangeCallBack="gcPopupConfigValueChangeCallBack"
          :checkValid="gcPopupIsValid"
          :ref="'gcPopupConfig-gc-popup-form-data'"
          formKey="gcPopupConfig-gc-popup-form-data"
        ></gc-form>
      </div>
    </gc-popup>

    <GcSundryTransactionPopup
      v-if="gcSundryTransactionPopupConfig.gcPopupVisible"
      :visible="gcSundryTransactionPopupConfig.gcPopupVisible"
      :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
      :setLoading="showLoading"
      :showValidationSummary="showValidationSummary"
    />

    <GcPopupSoPayNow
      v-if="gcSOPayNowPopupConfig.visible"
      :visible="gcSOPayNowPopupConfig.visible"
      :salesOrderCode="gcSOPayNowPopupConfig.salesOrderCode"
      :customerName="gcSOPayNowPopupConfig.customerName"
      :customerCode="gcSOPayNowPopupConfig.customerCode"
      :orderAmount="gcSOPayNowPopupConfig.orderAmount"
      :callback="gcSOPayNowPopupConfig.callback"
      :setLoading="showLoading"
    />

    <GcPopupSoPartPick
      v-if="gcSOPartPickPopupConfig.visible"
      :visible="gcSOPartPickPopupConfig.visible"
      :salesOrderCode="gcSOPartPickPopupConfig.salesOrderCode"
      :customerName="gcSOPartPickPopupConfig.customerName"
      :shipDate="gcSOPartPickPopupConfig.shipDate"
      :requiredByDate="gcSOPartPickPopupConfig.requiredByDate"
      :callback="gcSOPartPickPopupConfig.callback"
      :setLoading="showLoading"
      :customerCode="gcSOPartPickPopupConfig.customerCode"
    />

    <GcPopupBankTransfer
      v-if="gcPopupBankTransferConfig.visible"
      :visible="gcPopupBankTransferConfig.visible"
      :callback="gcPopupBankTransferConfig.callback"
      :showValidationSummary="showValidationSummary"
      :setLoading="showLoading"
    />

    <GcPopupCustomerStatement
      v-if="gcPopupCustomerStatementConfig.visible"
      :setVisible="gcPopupCustomerStatementConfig.visible"
      :hidden="gcPopupCustomerStatementConfig.hidden"
      :showLoading="showLoading"
      :dataObj="gcPopupCustomerStatementConfig.dataModel"
      :displayValidationSummary="displayValidationSummary"
    />

    <GcPopupDepositClaim
      v-if="gcPopupDepositClaimConfig.visible"
      :setVisible="gcPopupDepositClaimConfig.visible"
      :callBack="gcPopupDepositClaimConfig.callback"
      :salesOrderData="gcPopupDepositClaimConfig.data"
      :setLoading="showLoading"
    />
    <slot name="popup" />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { tabAccessControl } from "@/_helpers/access-control";
import { mapGetters } from "vuex";
import { TransactionListService } from "@/_services/api/templates/transactions-list.services";
import { CacheService } from "@/_services/cache/cache-service";
import GcPopupSoPayNow from "../popups/gc-popup-so-pay-now.vue";

/**
 * TODO - Move out the unused Popup and use the slot instead
 */
export default {
  props: {
    gcPopupDepositClaimConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    screenConfig: {
      type: Object,
      default: undefined,
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    persistenceKey: {
      type: String,
    },
    gcPopupConfig: {
      type: Object,
      default: () => {},
    },
    loadDataGrid: {
      type: Boolean,
      default: true,
    },
    gcSundryTransactionPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcSOPayNowPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcSOPartPickPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupCustomerStatementConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupBankTransferConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    backButtonRoute: {
      type: String,
      default: "/home",
    },

    backButtonEnable: {
      type: Boolean,
      default: false,
    },
    defaultUserSettings: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: { GcPopupSoPayNow },

  data() {
    return {
      loaded: false,
      gcPopupVisible: false,
      isValid: false,
      pageRefreshKey: new Date().getTime(),
      gcPopupIsValid: false,
    };
  },
  beforeDestroy() {
    this.loaded = false;
  },
  computed: {
    ...mapGetters({ getHotKeyCreateNew: "hotKey/getHotKeyCreateNew" }),
    ...mapGetters({ displayServerErrorPopUp: "ui/getServerError" }),
    tabsAccessControl() {
      if (this.screenConfig.tabs)
        return tabAccessControl(this.screenConfig.tabs);
      else return [];
    },
    getScreenName() {
      if (this.screenConfig.ScreenName) return this.screenConfig.ScreenName;
      else if (this.screenConfig.tabs && this.screenConfig.title) {
        return (
          this.screenConfig.title +
          " - " +
          this.screenConfig.tabs[this.screenConfig.selectedIndex].text
        );
      } else return undefined;
    },
  },
  beforeMount() {
    this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
    this.pageRefreshKey = new Date().getTime();
  },

  async created() {
    if (this.screenConfig.ScreenName) this.getReportPreviewScreenName();
    else this.loaded = true;

    if (
      this.screenConfig.gridData.toolbar.screenName &&
      (this.screenConfig.gridData.toolbar.pdf === true ||
        this.screenConfig.gridData.toolbar.multiplePdf === true)
    )
      this.$store.dispatch("reportPdfPreview/setReportPreviewScreens");
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    showValidationSummary(val) {
      if (val.length > 0) {
        this.displayValidationSummary(val);
      }
    },
    gcPopUpSaveOption() {
      this.gcPopupIsValid = true;
    },
    gcPopupConfigValueChangeCallBack(isValid, brokenRules) {
      this.gcPopupIsValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.gcPopupConfig.save.clickCallback(
          this.gcPopupConfig.dataModel ? this.gcPopupConfig.dataModel : {}
        );
      }
    },
    popUpBackButtonClick() {
      this.gcPopupVisible = false;
      if (this.gcPopupConfig) this.gcPopupConfig.callBack();
    },
    async getReportPreviewScreenName() {
      var data = [];

      if (CacheService.getCache("ReportPreviewScreens")) {
        data = CacheService.getCache("ReportPreviewScreens").filter(
          (x) => x.ScreenName === this.screenConfig.ScreenName
        );
      } else {
        await TransactionListService.getReportPreviewScreens()
          .then((res) => {
            CacheService.saveCache("ReportPreviewScreens", res.data.value, 5);
            data = res.data.value.filter(
              (x) => x.ScreenName === this.screenConfig.ScreenName
            );
          })
          .catch((err) => {
            if (err) this.getReportBackgroundScreenName();
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordPDFView"
      );
      if (index !== -1) {
        let pdfPreviewData = data.filter(
          (x) => x.AvailableForPDFPreview === "Y"
        );
        this.screenConfig.gridData.columns[index].PrintPreview = pdfPreviewData;
        if (data.length === 0 || pdfPreviewData.length === 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      var emailColumnIndex = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordEmail"
      );

      if (emailColumnIndex !== -1) {
        let emailData = data.filter((x) => x.AvailableForEmail === "Y");

        this.screenConfig.gridData.columns[emailColumnIndex].BackgroundEmail =
          emailData;
        if (data.length === 0 || emailData.length === 0)
          this.screenConfig.gridData.columns[emailColumnIndex].visible = false;
      }

      this.getReportBackgroundScreenName();
    },
    async getReportBackgroundScreenName() {
      var data = [];

      if (CacheService.getCache("ReportBackgroundScreens")) {
        data = CacheService.getCache("ReportBackgroundScreens").filter(
          (x) => x.ScreenName === this.screenConfig.ScreenName
        );
      } else {
        await TransactionListService.getReportBackgroundScreens({
          select: [
            "RecordID",
            "ReportDisplayName",
            "ScreenName",
            "Status",
            "TransactionCode",
          ],
        })
          .then((res) => {
            CacheService.saveCache(
              "ReportBackgroundScreens",
              res.data.value,
              5
            );
            data = res.data.value.filter(
              (x) => x.ScreenName === this.screenConfig.ScreenName
            );
          })
          .catch((err) => {
            if (err) this.loaded = true;
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordPrint"
      );
      if (index !== -1) {
        this.screenConfig.gridData.columns[index].BackgroundPrint = data;
        if (data.length === 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      this.loaded = true;
    },

    rowClickCallBack(e) {
      if (this.screenConfig.gridData.gridOptions.rowSelect)
        this.onRowClicked(e, this.screenConfig.gridData.gridOptions.rowSelect);
      else this.rowClick(e);
    },
  },
  watch: {
    getHotKeyCreateNew(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyCreateNew", false);
        if (
          this.screenConfig &&
          this.screenConfig.gridData &&
          this.screenConfig.gridData.toolbar
        ) {
          if (this.screenConfig.gridData.toolbar.customButtons) {
            var customButtons =
              this.screenConfig.gridData.toolbar.customButtons;
            var addNew = customButtons.filter(
              (x) => x.icon === "plus" || x.label === "Add New"
            );
            if (addNew.length > 0) {
              this.setIgnoreRouteChangeConfirmation();
              var element = addNew[0];
              if (element.routeAction)
                this.$router.push({
                  path: element.routeAction(),
                  query: element.routeQuery ? element.routeQuery : undefined,
                });
              else if (
                element.clickAction &&
                typeof element.clickAction === "function"
              )
                element.clickAction();
              else
                this.$router.push({
                  path: element.route,
                  query: element.routeQuery ? element.routeQuery : undefined,
                });
            }
          }
        }
      }
    },
    displayServerErrorPopUp(val) {
      if (val) {
        this.displayServerError(val.error, val.title);
      }
    },
    setLoading(val) {
      this.showLoading(val);
    },
    gcPopupConfig: {
      handler(val) {
        if (this.gcPopupVisible !== val.gcPopupVisible)
          this.gcPopupVisible = val.gcPopupVisible;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
